import { ThemeUICSSObject } from '@apia/theme';
import { defaultView } from './defaultView';
import infoModal from './infoModal';
import dropzone from './dropzone';
import verifySignModal from './verifySignModal';
import { filesList } from './filesList';
import { permissions } from './permissions';
/* IMPORT HERE */

const uploader: ThemeUICSSObject = {
  defaultView,
  dropzone,
  infoModal,
  filesList,
  permissions,
  verifySignModal,
  tooltip: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,

    '.head': {
      textDecoration: 'underline',
    },

    '.fileBtn': {
      '&.disabled': {
        cursor: 'not-allowed',
        backgroundColor: 'form.fields.disabled.backgroundColor',
      },

      '&.readonly, &:redonly': {
        // backgroundColor: 'form.fields.readonly.backgroundColor',
        backgroundColor: 'red!important',
      },
    },
  },
  /* PREPEND HERE */
};

export default uploader;
